import { FlowStepper } from "@vixi/ui";
import { FC } from "react";

interface LinkedInStepperProps {
  activeStep: number;
}

export const LinkedInStepper: FC<LinkedInStepperProps> = ({ activeStep }) => {
  return (
    <div className="flex grow-1 items-center justify-center">
      <FlowStepper
        steps={[
          "CreateCourseStepper.AddContent",
          "CreateCourseStepper.CourseGeneration",
          "CreateCourseStepper.CreateCharacter",
          "CreateCourseStepper.Review",
          "CreateCourseStepper.CourseCreated",
        ]}
        activeStep={activeStep}
      />
    </div>
  );
};
